var _excluded = ["isExpanded", "toggleExpanded"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '../../../foundations/Icon';
import { forwardRef } from '../../../utils';
import { _TableCell } from '../_TableCell'; // eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private Please do not use this component. It's for internal use only in `@melio/penny`.
 */
export var _TableExpandCell = forwardRef((_ref, ref) => {
  var {
    isExpanded,
    toggleExpanded
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = event => {
    event.stopPropagation();
    toggleExpanded();
  };

  return /*#__PURE__*/_jsx(_TableCell, _objectSpread(_objectSpread({
    "data-component": "TableExpandCell",
    ref: ref,
    onClick: handleClick
  }, props), {}, {
    textAlign: "center",
    children: /*#__PURE__*/_jsx(Icon, {
      type: "".concat(isExpanded ? 'chevron-down' : 'chevron-right'),
      "aria-label": "".concat(isExpanded ? 'Expanded' : 'Closed')
    })
  }));
});
_TableExpandCell.displayName = 'TableExpandCell';
//# sourceMappingURL=_TableExpandCell.js.map